import type { PlanBenefits } from '../../types/planBenefits';
import type { PromoCampaign } from './types';
import { PROMO_CAMPAIGNS } from './campaigns';

const isInPeriod = (campaign: PromoCampaign, nowMs: number): boolean =>
  Date.parse(campaign.period.startDate) <= nowMs &&
  nowMs < Date.parse(campaign.period.endDate);

/** Campanha ativa para o plano e o canal, sem olhar a face (textos da tela toda). Sem hora do servidor, nenhuma. */
export function getActivePromo(
  planBenefits: PlanBenefits | null | undefined,
  channel: string | null,
  nowMs: number | null,
  campaigns: PromoCampaign[] = PROMO_CAMPAIGNS,
): PromoCampaign | null {
  if (nowMs === null || !planBenefits?.category) return null;

  return (
    campaigns.find(
      campaign =>
        campaign.conditions.category === planBenefits.category &&
        campaign.conditions.channel === channel &&
        isInPeriod(campaign, nowMs),
    ) ?? null
  );
}

/** Campanha ativa para uma face específica (id em centavos). */
export function getActivePromoForFace(
  planBenefits: PlanBenefits | null | undefined,
  channel: string | null,
  faceId: number,
  nowMs: number | null,
  campaigns: PromoCampaign[] = PROMO_CAMPAIGNS,
): PromoCampaign | null {
  const campaign = getActivePromo(planBenefits, channel, nowMs, campaigns);
  if (!campaign || faceId < campaign.conditions.minFace) return null;
  return campaign;
}

/** Hora do servidor a partir da diferença de relógio guardada na store (null sem serverDate). */
export const getServerNow = (
  serverTimeOffsetMs: number | null,
): number | null =>
  serverTimeOffsetMs === null ? null : Date.now() + serverTimeOffsetMs;
